import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia();
window.mm = mm;
// gsap.registerPlugin(ScrollTrigger);

const initTimeline = (device) => {
    let sections = gsap.utils.toArray(".timeline .scene");
    let timelinePinEnd = sections.length * 1000;
    let moveTimeline = $('.timeline').outerWidth() - window.innerWidth;
    let startTop = 97;
    let reverseMax;
    if (device == 'mobile') {
        startTop = 106;
    }
    if (!$('.timeline').hasClass('design-mode')) {

        let scrollTween = gsap.to('.timeline', {
            x: `-${moveTimeline}px`,
            ease: "none", // <-- IMPORTANT!
            scrollTrigger: {
                trigger: ".timeline-content",
                pin: '.timeline-content',
                scrub: true,
                start: `top top+=${startTop}`,
                end: "+=3000",
                markers: false,
                onUpdate: self => {
                    var scrollProgress = Math.round(self.progress.toFixed(2) * 100);

                    // console.log(scrollProgress, self);
                    gsap.to('#progress-bar #progress-bar-inner', {
                        width: scrollProgress + "%",
                        ease: "none"
                    });
                    if (self.direction == 1) {
                        const targetElements = filterElementsByDataTreeRange(1, scrollProgress, '[data-tree]:not([style*="scale"])');
                        reverseMax = scrollProgress;
                        gsap.to(targetElements, {
                            scale: 1,
                            duration: 0.5,
                            ease: "back.out(1.7)"
                        });
                    } else {
                        const targetElements = filterElementsByDataTreeRange(scrollProgress, reverseMax, '[data-tree]');
                        gsap.to(targetElements, {
                            scale: 0,
                            duration: 0.5,
                            ease: "back.in(1.7)",
                            onComplete: () => {
                                gsap.set(targetElements, { clearProps: 'all' });
                            }
                        });
                        reverseMax = scrollProgress;
                    }
                }
            }
        });

        $('.timeline .scene').each(function (index) {
            let scene = $(this).attr('id'),
                sceneIndex = $(this).attr('data-index'),
                triggerStart = 'right',
                triggerEnd = 'left',
                moveFrom = '-10%',
                moveTo = '0%',
                moveLayer1From = '0%',
                moveLayer1To = '-20%';
            if (sceneIndex == 1) {
                triggerStart = 'left',
                    triggerEnd = 'left',
                    moveFrom = '0%',
                    moveTo = '10%',
                    moveLayer1From = '0%',
                    moveLayer1To = '10%';
            }
            let move2 = $(`#${scene} .img-layer-wrap[data-layer="2"]`).outerWidth() - $(this).outerWidth();
            //console.log('scene width = ' + $(this).outerWidth());
            //console.log('data-layer="2 = ' + $(`#${scene} .img-layer-wrap[data-layer="2"]`).outerWidth());
            gsap.fromTo(`#${scene} .img-wrap`, {
                x: moveFrom
            }, {
                x: moveTo,
                ease: "none",
                scrollTrigger: {
                    trigger: `#${scene}`,
                    containerAnimation: scrollTween,
                    start: `left ${triggerStart}`,
                    end: `right ${triggerEnd}`,
                    scrub: true,
                    id: sceneIndex,
                    markers: false
                }
            });
            //console.log(scene, sceneIndex);
            ScrollTrigger.create({
                trigger: `#${scene}`,
                containerAnimation: scrollTween,
                start: `left left`,
                end: `right left`,
                markers: false,
                //onToggle: self => console.log("toggled, isActive:", self.isActive),
                onEnter: () => {
                    // $('.timeline .scene').removeClass('active');
                    $(`#progress-dates .date[data-index="${sceneIndex}"]`).addClass('active');
                },
                onEnterBack: () => {
                    // $('.timeline .scene').removeClass('active');
                    $(`#progress-dates .date[data-index="${sceneIndex}"]`).addClass('active');
                },
                onLeave: () => {
                    // $('.timeline .scene').removeClass('active');
                    $(`#progress-dates .date[data-index="${sceneIndex}"]`).removeClass('active');
                },
                onLeaveBack: () => {
                    // $('.timeline .scene').removeClass('active');
                    $(`#progress-dates .date[data-index="${sceneIndex}"]`).removeClass('active');
                }
            });
            gsap.fromTo(`#${scene} .img-layer-wrap[data-layer="2"]:not([data-effect="fix"])`, {
                x: 0
            }, {
                x: -move2,
                ease: "none",
                scrollTrigger: {
                    trigger: `#${scene}`,
                    containerAnimation: scrollTween,
                    start: "left right",
                    end: "right left",
                    scrub: true,
                    id: index,
                    markers: false
                }
            });
            gsap.fromTo(`#${scene} .img-layer-wrap[data-effect="fix"]`, {
                xPercent: -100
            }, {
                xPercent: 100,
                ease: "none",
                scrollTrigger: {
                    trigger: `#${scene}`,
                    containerAnimation: scrollTween,
                    start: "left right",
                    end: "right left",
                    scrub: true,
                    id: index,
                    markers: false
                }
            });
            gsap.fromTo(`#${scene} .scene-columns.fix_text`, {
                xPercent: -100
            }, {
                xPercent: 100,
                ease: "none",
                scrollTrigger: {
                    trigger: `#${scene}`,
                    containerAnimation: scrollTween,
                    start: "left right",
                    end: "right left",
                    scrub: true,
                    id: index,
                    markers: false
                }
            });
        });
    }
}

mm.add("(min-width: 768px)", () => {
    initTimeline('desktop');
});
mm.add("(max-width: 768px)", () => {
    initTimeline('mobile');
});

function filterElementsByDataTreeRange(min, max, target) {
    const allElements = $(target);
    const filteredElements = [];

    allElements.each(function () {
        const treeValue = parseInt($(this).data('tree'), 10);

        if (treeValue >= min && treeValue <= max) {
            filteredElements.push(this);
        }
    });

    return filteredElements;
}